/**
 * Hour and minute component, persisted in seconds.
 * @author: Victor Minerva & Luis Caminha
 * Date: 26/05/21
 * Time: 16:00
*/

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeHoursSecondsField = (function () {

    function TimeHoursSecondsField () {

        Monet.UI.Fields.TimeField.apply(this, arguments);

        this.getValue = function () {
            if (this.input.value === "") {
                return "";
            }

            const valueInSeconds = new Monet.Format
                .SECONDS(this.input.value)
                .convertHourToSeconds()
                .getValue();

            return valueInSeconds;
        };

        this.setInputValue = function () {
            if (this.input && this.value) {
                this.input.value = this.value;
            }
        };

        this.setValue = function (value) {
            if (value) {
                const convertedValue = new Monet.Format
                    .SECONDS(value)
                    .convertSecondsToHourMinutes()
                    .getValue();

                this.value = convertedValue;
                this.setInputValue();
            }
        };

        this.initializeSpecialBehavior = function () {
            new Monet.Date
                .GeneralFunctions()
                .setTimePicker(this.input, this.meta ?? null, 'HH:mm');
        };

    }

    return TimeHoursSecondsField;

}());
